import { Field, NetworkIcon, Select, TokenIcon } from "@unizpay/ui";
import { WithIcon } from "./AssetLabel";

/**
 * A network select and a token select side by side; the token list depends on the network.
 * The parent owns both values and decides which token to keep when the network changes.
 */
export function NetworkTokenPicker({
  networks,
  network,
  onNetworkChange,
  tokens,
  token,
  onTokenChange,
  tokenLabel = "Token",
  networkHint,
  tokenHint,
  error,
}: {
  networks: Array<{ value: string; label: string }>;
  network: string;
  onNetworkChange: (network: string) => void;
  tokens: string[];
  token: string;
  onTokenChange: (token: string) => void;
  tokenLabel?: string;
  networkHint?: string;
  tokenHint?: string;
  error?: string;
}) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <Field label="Network" hint={networkHint} error={error}>
        {(p) => (
          <WithIcon icon={network ? <NetworkIcon network={network} size={18} /> : null}>
            <Select
              {...p}
              className={network ? "pl-9" : undefined}
              value={network}
              onChange={(e) => onNetworkChange(e.target.value)}
            >
              {networks.map((n) => (
                <option key={n.value} value={n.value}>
                  {n.label}
                </option>
              ))}
            </Select>
          </WithIcon>
        )}
      </Field>
      <Field label={tokenLabel} hint={tokenHint}>
        {(p) => (
          <WithIcon icon={token ? <TokenIcon symbol={token} size={18} /> : null}>
            <Select
              {...p}
              className={token ? "pl-9" : undefined}
              value={token}
              onChange={(e) => onTokenChange(e.target.value)}
            >
              {tokens.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </Select>
          </WithIcon>
        )}
      </Field>
    </div>
  );
}
